import BaseComponent from '../BaseComponent';
import './ColorPicker.css';

import {Circle, Hue, Material, Saturation} from '@uiw/react-color';
import {hexToHsva, hsvaToHex} from '@uiw/color-convert'

import PropTypes from "prop-types";
import VerticalLayout from "../layouts/VerticalLayout";
import HorizontalLayout from "../layouts/HorizontalLayout";
import {IconButton, Typography} from "@mui/material";
import {Close} from "@mui/icons-material";

/**
 * @property string   hex: Farbwert als Hex-Wert: Bsp. #225588
 * @property string[] colors: Schnell-Auswahlfarben: Bsp. ['#f44e3b', '#fe9200', '#fcdc00', '#dbdf00']
 */
class ColorPicker extends BaseComponent {

  constructor(props) {
    super(props);
    let hsva = hexToHsva(this.props.hex);
    this.state = {
      color: props.color, hsva: hsva, hex: this.props.hex
    };
    this.colors = ['#fff', '#000', '#6f00ff', '#4b0082'];
    if (props.colors !== undefined && props.colors !== null) {
      this.colors = this.colors.concat(this.props.colors);
    }
  }

  createColorPicker() {
    return <VerticalLayout className="min-w-[300px] max-w-[340px] bg-cn-color-black cn-border-radius-10 p-3 gap-2 cn-shadow-button">
      <HorizontalLayout className="justify-between">
        <Typography variant='h6'>Color Picker</Typography>
        {this.props.onClose && <IconButton size='small' onClick={this.props.onClose}>
          <Close/>
        </IconButton>}
      </HorizontalLayout>
      <Saturation
        hsva={this.state.hsva}
        onChange={(newColor) => {
          this.state.hsva = {...this.state.hsva, ...newColor, a: this.state.hsva.a};
          this.state.hex = hsvaToHex(this.state.hsva);
          this.onPickerChange();
          this.setState(this.state);
        }}
      />
      <Hue
        hue={this.state.hsva.h}
        onChange={(newHue) => {
          let hsva = {h: newHue.h, s: this.state.hsva.s, v: this.state.hsva.v, a: this.state.hsva.a};
          let hex = hsvaToHex(this.state.hsva);
          this.setState({hex: hex, hsva: hsva});
          this.onPickerChange();
        }}
      />
      {/*<Alpha*/}
      {/*    hsva={this.state.hsva}*/}
      {/*    onChange={(newAlpha) => {*/}
      {/*        console.log(newAlpha)*/}
      {/*        this.state.hsva = {h: this.state.hsva.h, s: this.state.hsva.s, v: this.state.hsva.v, a: newAlpha.a};*/}
      {/*        this.state.hex = hsvaToHex(this.state.hsva);*/}
      {/*        this.setState(this.state);*/}
      {/*    }}*/}
      {/*/>*/}

      <Material
        color={this.state.hex}
        onChange={(color) => {
          this.setState({hex: color.hex, hsva: color.hsva});
          this.onPickerChange();
        }}/>

      {/*<Circle*/}
      {/*  className="mt-2"*/}
      {/*  colors={this.colors}*/}
      {/*  color={this.state.hex}*/}
      {/*  onChange={(color) => {*/}
      {/*    this.setState({hex: color.hex, hsva: color.hsva});*/}
      {/*    this.onPickerChange();*/}
      {/*  }}*/}
      {/*/>*/}
    </VerticalLayout>;
  }

  onPickerChange() {
    if (this.props.onChange) {
      this.props.onChange(this.state.hex);
    }
  }

  render() {
    return this.createColorPicker()
  }
}

ColorPicker.propTypes = {
  onChange: PropTypes.func, hex: PropTypes.string, colors: PropTypes.arrayOf(PropTypes.string)
}
export default ColorPicker
